import { ShadowedPointSymbol } from "./ShadowedPointSymbol";
import { snappingSymbolParams } from "./ShadowedPolySymbol";

export const createSnappingSymbol = (snappingDistance: number) => {
  return new ShadowedPointSymbol({
    ...snappingSymbolParams,
    outlineRadius: snappingDistance,
  });
};
